module.exports = __webpack_public_path__ + "static/media/history@2x.e37083fd.png";